import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {highlightCode, highlightName} from './code-highlight.mjs';
import type {CodeFragment} from './code-highlight.mjs';

@Component({
  selector: 'app-search-code-highlight',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *ngFor="let fragment of fragments"><strong *ngIf="fragment.matched; else plain">{{ fragment.text }}</strong><ng-template #plain>{{ fragment.text }}</ng-template></ng-container>
  `,
  styles: [':host { white-space: pre-wrap; font-weight: normal; } strong { font-weight: 700; }']
})
export class SearchCodeHighlightComponent implements OnChanges {
  @Input() code: string | null | undefined = '';
  @Input() query: string | null | undefined = '';
  @Input() field: 'code' | 'name' = 'code';
  @Input() productCode: string | null | undefined = '';
  fragments: CodeFragment[] = [];

  ngOnChanges(): void {
    this.fragments = this.field === 'name'
      ? highlightName(this.code, this.query, this.productCode)
      : highlightCode(this.code, this.query);
  }
}
